/* Gamme — Ajout au panier des cartes produit (gamme-pillar) + ouverture du cart drawer.
   Delegue sur document : fonctionne quel que soit le nombre de blocs gamme-pillar sur la page.
   Charge une seule fois (dedup navigateur via asset_url). */
(function () {
  'use strict';
  if (window.__omadsGammeAtc) return;
  window.__omadsGammeAtc = true;

  function refreshCartDrawer() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    return fetch(root + '?sections=cart-drawer')
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function (sections) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && sections['cart-drawer']) {
          var parser = new DOMParser();
          var newDoc = parser.parseFromString(sections['cart-drawer'], 'text/html');
          var newDrawer = newDoc.querySelector('cart-drawer');
          if (newDrawer) drawer.innerHTML = newDrawer.innerHTML;
          drawer.classList.remove('is-empty');
          if (typeof drawer.open === 'function') drawer.open();
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.gd-card__atc');
    if (!btn || btn.disabled) return;
    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function () {
        btn.classList.add('gd-card__atc--added');
        return refreshCartDrawer();
      })
      .then(function () {
        setTimeout(function () {
          btn.classList.remove('gd-card__atc--added');
          btn.disabled = false;
        }, 1500);
      })
      .catch(function () {
        btn.classList.remove('gd-card__atc--added');
        btn.disabled = false;
      });
  });
})();
